<section id="wrapper" class="error-page">
    <div class="error-box">
        <div class="error-body text-center">
            <h1>404</h1>
            <h3 class="text-uppercase">No se ha encontrado la página !</h3>
            <p class="text-muted m-t-30 m-b-30">Pero has encontrado otra cosa :)</p>
            <a routerLink="/login/cixpanel" class="btn btn-info btn-rounded waves-effect waves-light m-b-40">Regresar al login</a> </div>
        <footer class="footer text-center">© {{anio}} Cixteam</footer>
    </div>
</section>